import { firebaseDB, firebaseFunctions } from 'utils/firebase';
import { setDoc, doc, deleteDoc, query, collection, where, getDocs } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

const COLLECTION_NAME = 'configurations';

const addNewConfiguration = async configuration => {
	if (!configuration) return null;

	const res = await setDoc(doc(firebaseDB, COLLECTION_NAME, configuration.code), configuration);

	return res;
};

const deleteConfiguration = async configurationId => {
	if (!configurationId) return null;

	const res = await deleteDoc(doc(firebaseDB, COLLECTION_NAME, configurationId));

	return res;
};

const getGuestConfiguration = async code => {
	const configurationQuery = query(
		collection(firebaseDB, COLLECTION_NAME),
		where('code', '==', code),
		where('companyId', '==', null),
		where('type', '==', 'drafts')
	);

	const snap = await getDocs(configurationQuery);

	const res = [];

	snap.forEach(docSnap => {
		res.push(docSnap.data());
	});

	return res[0];
};

const hideAllConfigurations = async (
	action,
	orderType,
	orderStatus,
	companyId,
	asAdmin,
	selectedItems = null
) => {
	const hideAllConfigurationsFn = httpsCallable(firebaseFunctions, 'hideAllConfigurations');
	return hideAllConfigurationsFn({
		action,
		orderType,
		orderStatus,
		companyId,
		asAdmin,
		selectedItems,
	});
};

const CONFIGURATIONS_API = {
	addNewConfiguration,
	deleteConfiguration,
	getGuestConfiguration,
	hideAllConfigurations,
};

export default CONFIGURATIONS_API;
